<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Datatable from "@/router/layouts/table-datatable.vue";
import Pagination from "@/router/layouts/table-pagination.vue";
import axios from "axios";
import Swal from "sweetalert2";
import _ from "lodash";
import router from "../..";

export default {
  page: {
    title: "Starter Page",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, Datatable, Pagination },
  data() {
    let sortOrders = []; // select sortOrder

    // definisi kolom yang dipakai
    let columns = [
      {
        width: "50px",
        label: "No",
        name: "-",
      },
      {
        width: "auto",
        label: "Kode Penyusun",
        name: "kode",
      },
      {
        width: "auto",
        label: "Nama Penyusun",
        name: "nama",
      },
      {
        width: "auto",
        label: "User",
        name: "-",
      },
      {
        width: "300px",
        label: "Aksi",
        name: "-",
      }, // jika tidak ada sorting kasih name dengan karakter -
    ];

    // cek sorting
    columns.forEach((column) => {
      sortOrders[column.name] = -1;
    });

    return {
      title: "Penyusun Soal",
      loadingTable: true,
      tableData: [],
      columns: columns,
      sortKey: "created_at",
      sortOrders: sortOrders,
      currentTablePage: "",
      tableFilter: {
        page: 1,
        perPage: 10,
        search: "",
        column: "created_at",
        dir: "desc",
        status: "all",
        kode: "",
        nama: "",
      },
      pagination: {
        lastPage: "",
        currentPage: "",
        total: "",
        lastPageUrl: "",
        nextPageUrl: "",
        prevPageUrl: "",
        from: "",
        to: "",
        links: "",
      },
      formPayload: {},
      titleModal: "",
      showModal: false,
      modalTambah: false,
      modalEdit: false,
      optionUser: [],
    };
  },
  methods: {
    async getTableData(resetPage = true) {
      this.tableFilter.page = resetPage ? 1 : this.tableFilter.page;
      this.loadingTable = true;
      const data = await axios({
        method: "get",
        url: process.env.VUE_APP_BACKEND_URL_VERSION + "master/penyusun-soal",
        params: this.tableFilter,
        headers: {
          Authorization: `Bearer ${localStorage.access_token}`,
        },
      })
        .then((response) => response.data)
        .catch((err) => {
          console.log("err get data:", err);
          return false;
        });
      if (data) {
        this.tableData = data.data.data;
        this.currentTablePage = data.data.current_page;
        this.pagination.total = data.data.total;
        this.pagination.from = data.data.from;
        this.pagination.to = data.data.to;
        this.pagination.links = data.data.links;
        this.pagination.lastPageUrl = data.last_page_url;
        this.pagination.nextPageUrl = data.next_page_url;
        this.pagination.prevPageUrl = data.prev_page_url;
        this.pagination.per_page = this.tableFilter.per_page;
        this.pagination.page = this.tableFilter.page;
      }
      this.loadingTable = false;
    },
    toPage(url) {
      let link = new URLSearchParams(url);
      this.tableFilter.page = link.get("page");
      // this.tableFilter.per_page = link.get('per_page');
      this.getTableData(false);
    },
    sortBy(key) {
      this.sortKey = key;
      this.sortOrders[key] = this.sortOrders[key] * -1;
      this.tableFilter.column = key;
      this.tableFilter.dir = this.sortOrders[key] === 1 ? "asc" : "desc";
      this.getTableData();
    },
    create() {
      this.formPayload = {
        idpenyusun_soal: null,
        kode: "",
        nama: "",
        user: null,
        user_id: 0,
      };
      this.titleModal = "Tambah Penyusun Soal";
      this.showModal = true;
      this.modalTambah = true;
    },
    update(item) {
      this.formPayload = {
        idpenyusun_soal: item.idpenyusun_soal,
        kode: item.kode,
        nama: item.nama,
        user: item.user,
        user_id: item.user?.user_id ?? 0,
      };
      this.titleModal = "Edit Penyusun Soal";
      this.showModal = true;
      this.modalEdit = true;
    },
    save() {
      const method = this.modalTambah ? "post" : "put";
      const url = this.modalTambah
        ? process.env.VUE_APP_BACKEND_URL_VERSION + "master/penyusun-soal"
        : process.env.VUE_APP_BACKEND_URL_VERSION +
          "master/penyusun-soal/" +
          this.formPayload.idpenyusun_soal;
      this.formPayload.user_id = this.formPayload.user?.user_id;
      axios({
        method: method,
        url: url,
        data: this.formPayload,
        headers: {
          Authorization: `Bearer ${localStorage.access_token}`,
        },
      })
        .then((response) => {
          if (response.data.meta.status === "success") {
            Swal.fire({
              icon: "success",
              title: "Data Berhasil disimpan",
            });
            this.showModal = false;
            this.getTableData();
          } else {
            Swal.fire({
              icon: "error",
              title: "Gagal menyimpan data",
              text: response.data.message,
            });
          }
        })
        .catch((err) => {
          console.log("err save data:", err);
          Swal.fire({
            icon: "error",
            title: "Terjadi Kesalahan",
            text:
              err.response?.data?.data[0] ??
              "Silahkan coba kembali beberapa saat lagi",
          });
        });
    },
    destroy(id) {
      Swal.fire({
        icon: "warning",
        title: "Apakah Anda yakin menghapus data ini ?",
        text: "Data yang dihapus tidak dapat dipulihkan kembali.",
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: `Ya`,
        denyButtonText: `Tidak`,
      }).then(async (result) => {
        if (result.isConfirmed) {
          const data = await axios({
            method: "delete",
            url:
              process.env.VUE_APP_BACKEND_URL_VERSION +
              "master/penyusun-soal/" +
              id,
            headers: {
              Authorization: `Bearer ${localStorage.access_token}`,
            },
          })
            .then((response) => response.data)
            .catch((err) => {
              console.log("err delete data:", err);
              Swal.fire({
                icon: "error",
                text: "Terjadi Kesalahan",
                title: "Silahkan coba kembali beberapa saat lagi",
              });
              return false;
            });
          if (data) {
            Swal.fire({
              icon: "success",
              title: "Data Berhasil dihapus",
            });
            this.getTableData();
          }
        }
      });
    },
    exportData() {
      let params = new URLSearchParams(this.tableFilter);
      window.open(
        process.env.VUE_APP_BACKEND_URL_VERSION +
          "export-excel/penyusun-soal?" +
          params.toString(),
        "_blank",
      );
    },
    async setupKompetensi(row) {
      localStorage.setItem("penyusunSoal", JSON.stringify(row));
      localStorage.setItem("isFromMenuPenyusun", true);
      router.push({
        name: "all-kompetensi-level",
      });
    },
    async searchUser(search, loading) {
      loading(true);
      await this.getUser(search, loading);
    },
    async getUser(search = "", loading) {
      await axios
        .get(process.env.VUE_APP_BACKEND_URL_VERSION + "referensi/user/all", {
          params: {
            search: search,
            limit: 200,
          },
          headers: {
            Authorization: `Bearer ${localStorage.access_token}`,
          },
        })
        .then((response) => {
          this.optionUser = response.data.data.data;
          if (loading) loading(false);
        });
    },
  },
  mounted() {
    this.getTableData();
    this.getUser();
    this.filterData = _.debounce(this.getTableData.bind(this), 500);
    this.filterUser = _.debounce(this.searchUser.bind(this), 500);
    localStorage.removeItem('isFromMenuPenyusun');
  },
};
</script>
<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="d-flex justify-content-between align-items-center">
              <div class="card-title">Penyusun Soal</div>
              <div class="d-flex gap-2">
                <button class="btn btn-success btn-sm" @click="exportData()">
                  <i class="fa fa-file-excel me-1"></i> Export Excel
                </button>
                <button class="btn btn-primary btn-sm" @click="create()">
                  <i class="fa fa-plus me-1"></i> Tambah
                </button>
              </div>
            </div>
            <div class="row mt-2">
              <hr />
              <div class="form-group col-md-3">
                <label for="filterKode">Kode Penyusun</label>
                <input
                  type="text"
                  class="form-control"
                  id="filterKode"
                  v-model="tableFilter.kode"
                  placeholder="Filter Kode Penyusun"
                  @input="filterData"
                />
              </div>
              <div class="form-group col-md-3">
                <label for="filterKode">Nama Penyusun</label>
                <input
                  type="text"
                  class="form-control"
                  id="filterNama"
                  v-model="tableFilter.nama"
                  placeholder="Filter Nama Penyusun"
                  @input="filterData"
                />
              </div>
            </div>
            <div class="row mt-2">
              <hr />
              <div class="col-12">
                <table class="mb-2">
                  <tr>
                    <td>Show</td>
                    <td>
                      <select
                        class="form-control form-control-sm"
                        id="showpaginatetable"
                        v-model="tableFilter.per_page"
                        @change="getTableData()"
                      >
                        <option value="10">10</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                        <option value="200">200</option>
                        <option value="500">500</option>
                      </select>
                    </td>
                    <td>Entries</td>
                  </tr>
                </table>
              </div>
              <Datatable
                :columns="columns"
                :sortKey="sortKey"
                :sortOrders="sortOrders"
                @sort="sortBy"
              >
                <tbody>
                  <tr v-if="loadingTable">
                    <td colspan="99" class="text-center">
                      <i class="fa fa-spinner fa-spin me-1"></i> Loading...
                    </td>
                  </tr>
                  <tr v-else-if="tableData.length < 1">
                    <td colspan="99" class="text-center">Data Empty</td>
                  </tr>
                  <tr v-else v-for="(item, key) in tableData" :key="key">
                    <td>
                      <span v-if="key + 1 == 10">
                        {{ currentTablePage }}0.
                      </span>
                      <span v-else>
                        {{
                          currentTablePage - 1 != 0
                            ? currentTablePage - 1 + `${key + 1}`
                            : `${key + 1}`
                        }}.
                      </span>
                    </td>
                    <td>{{ item.kode }}</td>
                    <td>{{ item.nama }}</td>
                    <td>{{ item.user?.name ?? "-" }}</td>
                    <td>
                      <div class="btn-group btn-group-sm">
                        <button
                          class="btn btn-sm btn-info"
                          @click="setupKompetensi(item)"
                        >
                          <i class="fa fa-wrench me-1"></i> Setup Kompetensi
                        </button>
                        <button
                          class="btn btn-sm btn-primary"
                          @click="update(item)"
                        >
                          <i class="fa fa-edit me-1"></i> Edit
                        </button>
                        <button
                          class="btn btn-sm btn-danger"
                          @click="destroy(item.idpenyusun_soal)"
                        >
                          <i class="fa fa-trash me-1"></i> Hapus
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </Datatable>
              <Pagination :pagination="pagination" @toPage="toPage" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>

  <b-modal
    v-model="showModal"
    :title="titleModal"
    hide-footer
    @hidden="
      () => {
        modalTambah = false;
        modalEdit = false;
        formPayload = {};
      }
    "
  >
    <form @submit.prevent="save()">
      <div class="form-group mb-3">
        <label for="kode">
          Kode Penyusun <span class="text-danger">*</span>
        </label>
        <input
          type="text"
          class="form-control"
          id="kode"
          v-model="formPayload.kode"
          placeholder="Masukkan Kode Penyusun"
          required
        />
      </div>
      <div class="form-group mb-3">
        <label for="nama">
          Nama Penyusun <span class="text-danger">*</span>
        </label>
        <input
          type="text"
          class="form-control"
          id="nama"
          v-model="formPayload.nama"
          placeholder="Masukkan Nama Penyusun"
          required
        />
      </div>
      <div class="form-group mb-3">
        <label> User <span class="text-danger">*</span> </label>
        <v-select
          :options="optionUser"
          label="name"
          v-model="formPayload.user"
          placeholder="User"
          @search="filterUser"
        />
      </div>
      <div class="text-end">
        <button type="submit" class="btn btn-primary btn-sm">
          <i class="fa fa-save me-1"></i>
          Simpan
        </button>
      </div>
    </form>
  </b-modal>
</template>
